import { Action, createReducer, on, createFeatureSelector, createSelector, State } from '@ngrx/store';
import { GlobalAdapter } from '@core/store/adapters/global.adapter';

import * as GlobalAction from '@core/store/actions/global.action';
import { GlobalState } from '@core/entities/global.interface';

const initialState: GlobalState = {
  ui: {
  }
};

const globalReducerCreate = createReducer(
  initialState,
  on(GlobalAction.clearAll, () => initialState),
  on(GlobalAction.uiGlobal, (state, { ui }) => GlobalAdapter.setUi(ui, state)),
);

export function GlobalReducer(state: GlobalState, action: Action) {
  return globalReducerCreate(state, action);
}

export const getGlobal = createFeatureSelector<GlobalState>('global');
export const getUiGlobal = createSelector(getGlobal, ({ui}) => ui);
